// these are the same? :0
export const stripHTML = (dirtyString) => {
  return jQuery('<div/>').html(dirtyString).text();
};

export const stripHtml = (html) => {
  const temporalDivElement = document.createElement('div');
  temporalDivElement.innerHTML = html;
  return temporalDivElement.textContent || temporalDivElement.innerText || '';
};
